import React from 'react';
import { Divider, Stack } from '@mui/material';
import Pagination from '../../../components/common/Pagination';
import ProgressBar from '../../../components/common/ProgressBar';
import { useActivityData } from '../../../hooks/useActivityData';
import theme from '../../../theme';
import NoData from '../../../components/common/NoData';
import InFeedAd from '../../../components/ad/InFeedAd';
import { PAGE_TYPE } from '../../../constants/gaEnums';

const ITEMS_PER_AD = 5;

const ActivityTab = ({
  api,
  userId,
  ItemComponent,
  itemKey,
  adminMode = false,
  readOnly = false,
}) => {
  const { data, loading, totalCount, page, pageCount, handlePageChange, handleItemDelete } =
    useActivityData(api, userId);

  return (
    <ProgressBar isLoading={loading}>
      <Stack spacing={{ xs: '15px', md: '10px' }}>
        {data.map((item, index) => (
          <React.Fragment
            key={`${itemKey.split('.').reduce((obj, k) => obj?.[k], item) ?? `${item.category}-${index}`}-${index}`}
          >
            <ItemComponent
              data={item}
              onDelete={handleItemDelete}
              adminMode={adminMode}
              readOnly={readOnly}
            />
            <Divider sx={{ borderColor: theme.palette.grey.line }} />
            {(index + 1) % ITEMS_PER_AD === 0 && index < data.length - 1 && <InFeedAd pageType={PAGE_TYPE.MYPAGE} />}
          </React.Fragment>
        ))}
        {totalCount === 0 && !loading && <NoData />}
      </Stack>

      {/* 페이지네이션 */}
      {pageCount > 1 && <Pagination count={pageCount} page={page} onChange={handlePageChange} />}
    </ProgressBar>
  );
};

export default ActivityTab;
